// Package Imports
import { toJS } from "mobx";
import axios from "axios";

// Project Imports
import * as APITypes from "constants/API";
import AuthStore from "modules/login/store/AuthStore";
import updateProductwiseRiskData from "../updateProductwiseRiskData";
import generateChangeLADataStructure from "../change-la/generateChangeLADataStructure";
import { API_DELAY_TIME } from "constants/Constants";

const onChangeMaturityPayoutMode = async (requestObj) => {
  const journeyData = toJS(AuthStore.journeyData);
  let { journey_details } = journeyData;

  let needList = AuthStore.needMasterList;
  let selectedNeedData = needList.find((item) => item.id == requestObj.need_id);

  generateChangeLADataStructure(requestObj, selectedNeedData.unique_name);

  let requestList = [];
  let riskList = [];

  if (journey_details.high_risk_selected) {
    riskList.push("high");
  }
  riskList = [...riskList, ...["medium", "low"]];
  riskList.forEach((item) => {
    requestList.push({ ...requestObj, risk_type: item });
  });



  const promises = [];
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function makeRequests() {
    for (const item of requestList) {
      promises.push(axios.post(APITypes.CHANGE_NEW_TARGET_AMOUNT, item, item));
      await delay(API_DELAY_TIME);
    }

    await Promise.all(promises.map((item) =>
      item.then((result) => updateProductwiseRiskData(result))
    ));
  }
  makeRequests()
    .then(() => {
      console.log("All requests completed");
    })
    .catch((error) => {
      console.error("Error making requests: ", error);
    });
};

export default onChangeMaturityPayoutMode;